/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EmailSignatureUpdateSignatureKind = typeof EmailSignatureUpdateSignatureKind[keyof typeof EmailSignatureUpdateSignatureKind] | null;


export const EmailSignatureUpdateSignatureKind = {
  rich: 'rich',
  template: 'template',
} as const;
